import * as React from 'react';
import { Modal } from '../internal/Modal';
/** CustomDialog */
export const CustomDialog = ({ className, children, isOpen = false, onClose, manualFocus = false, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, 'data-hook': dataHook, appendToBody = false, }) => {
    return (React.createElement(Modal, { className: className, "data-hook": dataHook, isOpen: isOpen, focusTrap: !manualFocus, onRequestClose: onClose, appendToBody: appendToBody },
        React.createElement("div", { role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy }, children)));
};
CustomDialog.displayName = 'CustomDialog';
//# sourceMappingURL=CustomDialog.js.map